export default [
  {
    id: 1,
    label: 'Активный',
    value: true,
    cssClass: 'text-success',
  },
  {
    id: 2,
    label: 'Неактивный',
    value: false,
    cssClass: 'text-danger',
  },
];
